import { render } from "./ChatApi.vue?vue&type=template&id=2920d9ca"
const script = {}

import "./ChatApi.vue?vue&type=style&index=0&id=2920d9ca&lang=css"

import exportComponent from "E:\\code\\my\\bookmark.vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__